import { action, computed, observable, makeObservable } from 'mobx';
import { CollectionModelFieldLine } from '@ikegps/core-shared';
import { IkeGeodesic } from '@ikegps/core-measurement';
import type { MeasurementPoint } from './measurement.state';

/** In-progress state for drawing an Office line on the map. Multi-vertex (unlike the 2-point distance tool). */
export class LineDrawState {
	@observable points: MeasurementPoint[] = [];
	@observable isActive: boolean = false;
	@observable.ref targetField: CollectionModelFieldLine | null = null;
	/** Line type chosen up-front for this draw; only applied to the field on Complete. */
	@observable pendingLineType: string = '';

	constructor() {
		makeObservable(this);
	}

	@action.bound
	begin(field: CollectionModelFieldLine, lineType: string) {
		this.targetField = field;
		this.points = [];
		this.isActive = true;
		this.pendingLineType = lineType;
	}

	@action.bound
	setPendingLineType(title: string) {
		this.pendingLineType = title;
	}

	@action.bound
	addPoint(point: MeasurementPoint) {
		this.points.push(point);
	}

	@action.bound
	updatePointLocation(id: string, location: google.maps.LatLng) {
		const point = this.points.find((p) => p.id === id);
		if (point) {
			point.location = location;
		}
	}

	@action.bound
	removePoint(pointId: string) {
		const index = this.points.findIndex((p) => p.id === pointId);
		if (index !== -1) {
			this.points.splice(index, 1);
		}
	}

	@action.bound
	reset() {
		this.points = [];
		this.isActive = false;
		this.targetField = null;
		this.pendingLineType = '';
	}

	@computed get pointCount(): number {
		return this.points.length;
	}

	@computed get totalDistanceMeters(): number {
		if (this.points.length < 2) {
			return 0;
		}
		return IkeGeodesic.getPolylineDistance(
			this.points.map((p) => ({ latitude: p.location.lat(), longitude: p.location.lng() }))
		);
	}
}
